/**
 * cacheBudget.js — потолок кэша Cornerstone по устройству.
 *
 * Появился из-за перевёрнутой формулы в streamingManager: для слабых устройств
 * там стояло Math.max(1536, ...), то есть телефону ГАРАНТИРОВАЛСЯ кэш не меньше
 * полутора гигабайт — вместо того, чтобы им ограничиться. Cornerstone честно
 * не чистил кэш до 1.5 ГБ, а телефонный браузер выгружал вкладку задолго до
 * этой отметки. Слабее устройство — больше разрешали держать: ровно наоборот.
 *
 * Правило отдельным файлом без импортов, чтобы его можно было проверить
 * тестом и чтобы второй копии (как это уже было с прореживанием срезов) не
 * завелось.
 */

/**
 * @param {object} p
 * @param {boolean} [p.isMobile]
 * @param {number} [p.tierLevel] 0 слабое / 1 среднее / 2 сильное
 * @param {number} [p.vramMB]
 * @param {number} [p.deviceMemoryGB] navigator.deviceMemory (браузер не сообщает больше 8)
 * @returns {{mb: number, reason: string}}
 */
export function planCacheBudget({ isMobile = false, tierLevel = 2, vramMB = 512, deviceMemoryGB = 8 } = {}) {
  // Телефону хватает 512 МБ: объём с бюджетом срезов ~100 МБ, кадры серии,
  // запас. Больше — не «быстрее», а ближе к выгрузке вкладки целиком.
  if (isMobile) return { mb: 512, reason: 'телефон: вкладку выгружают раньше, чем кэш поможет' };
  if (tierLevel === 0) return { mb: 768, reason: 'слабое железо' };
  if (tierLevel === 1) return { mb: 1024, reason: 'среднее железо' };
  let mb = Math.min(2048, Math.max(1024, Math.floor((vramMB || 512) * 2)));
  if ((deviceMemoryGB || 8) <= 8) mb = Math.min(mb, 1536);
  return { mb, reason: 'сильное железо' };
}

export default { planCacheBudget };
